export default __webpack_public_path__ + "static/media/hero-video-square-es.a7918137.mp4";